export default __webpack_public_path__ + "aabeb1f36a13dca76c7646fe3654e4fc.svg";